import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../utils/localization-ag-grid";
import {useQuery} from "@tanstack/react-query";
import {FaPlusSquare} from "react-icons/fa";

import TemplateDefault from "../../components/template-default";
import Card from "../../components/card";
import Button from "../../components/button";
import resalesService from "../../services/templates-service";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css"
import {useNavigate} from "react-router-dom";
import InputForm from "../../components/input-form";
import {buildAccentInsensitiveColDef, setAccentInsensitiveQuickFilter} from "../../utils/ag-grid-quick-filter";

const Templates = () => {
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "SISTEMA INTERNO";
    }, []);

    const {data: resales} = useQuery({
        queryFn: () => resalesService.list().then(({data}) => data),
        queryKey: ['templates', 'list']
    });

    const [columnDefs] = useState([
        { field: "id", headerName: "Id", width: 40 },
        { field: "name", headerName: "Nome", flex: 1, minWidth: 300 },
        { field: "description", headerName: "Descrição", flex: 1, minWidth: 300 }
    ]);

    const gridRef = useRef();

    const defaultColDef = useMemo(() => {
        return buildAccentInsensitiveColDef({resizable: false});
    }, []);

    const onFilterTextBoxChanged = useCallback(({target}) => {
        setAccentInsensitiveQuickFilter(gridRef, target.value);
    }, []);

    const onCellClicked = (cell) => window.top.open(`/templates/form/${cell.data.id}`);

    return (
        <TemplateDefault title="Templates">
            <Card>
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-12">
                    <Button col="col-span-3" onClick={() => navigate("/templates/form")}>
                        <FaPlusSquare/> Novo template
                    </Button>

                    <InputForm id="search" col="col-span-9" label="Pesquisar" type="search"
                               onChange={onFilterTextBoxChanged}/>
                </div>

                <div className={"ag-theme-quartz grid mt-4"} style={{height: "calc(100vh - 185px)"}}>
                    <AgGridReact
                        ref={gridRef}
                        rowHeight={32}
                        rowData={resales}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        pagination
                        paginationPageSize={10}
                        paginationPageSizeSelector={[10, 25, 50, 100]}
                        animateRows={false}
                        suppressRowClickSelection={true}
                        suppressCellFocus={true}
                        onCellClicked={onCellClicked}
                        gridOptions={{localeText: LocalizationAgGrid}}
                    />
                </div>
            </Card>
        </TemplateDefault>
    );
};

export default Templates;
